import http from '../common/http';

const headers = {
  'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
};

const USER_STORAGE = 'user';

export default {
  register(user) {
    return new Promise(resolve => {
      const orheaders = {
        'Content-type': 'application/json'
      };

      http
        .post('/Authentication/register', user, {
          orheaders
        })
        .then(resp => {
          resolve(resp);
        });
    });
  },

  login(username, password) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      params.append('username', username);
      params.append('password', password);
      http
        .post('/Authentication/login', params, {
          headers
        })
        .then(resp => {
          const user = { username, roles: resp.data.roles };
          sessionStorage.setItem(USER_STORAGE, JSON.stringify(user));
          resolve(resp);
        })
        .catch(err => {
          sessionStorage.removeItem(USER_STORAGE);
          console.log(err);
          reject(err);
        });
    });
  },

  logout() {
    return new Promise((resolve, reject) => {
      http
        .get('/Authentication/logout')
        .then(resp => {
          sessionStorage.removeItem(USER_STORAGE);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  isAuthenticated() {
    return sessionStorage.getItem(USER_STORAGE) !== null;
  },

  getUserRoles() {
    if (sessionStorage.getItem(USER_STORAGE)) {
      const user = JSON.parse(sessionStorage.getItem(USER_STORAGE));
      return user.roles;
    }
    return [];
  },

  userHasRole(rolesToCheck) {
    const userRoles = this.getUserRoles();
    let hasRole = false;
    if (userRoles && userRoles.length) {
      rolesToCheck.forEach(role => {
        userRoles.forEach(userRole => {
          if (role === userRole) {
            hasRole = true;
          }
        });
      });
    }
    return hasRole;
  }
};
